export const texts = {
  search: 'Caută',
  vueVeeMax: 'Câmpul trebuie să aibă o lungime de maxim {length} caractere',
  partnerLabel: 'Furnizor',
  loading: 'Se încarcă',
  unauthMessage: 'Nu ai dreptul să efectuezi această operațiune'
}
